export class LinkedInResponseModel {
    emailAddress: string;
    firstName: string;
    id: string;
    lastName: string;
    pictureUrl: string;
  }